(ns manage.ad-variant.page.db
  (:require [re-frame.core :as rf]))

(rf/reg-sub ::selection
  (fn [db _]
    (:selection (::state db))))
